/**
 *
 * Taxonomies
 *
 */
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { List } from './List';
import { Edit } from './Edit';

interface Props {}

export function Taxonomies(props: Props) {
  return (
    <Routes>
      <Route path={``} element={<List />} />
      <Route path={`:id/:subsection?`} element={<Edit />} />
    </Routes>
  );
}
